import { gql } from '@apollo/client';

export const SET_INCOMING_GOODS_INFORMATION = gql`
    mutation SetIncomingGoodsInformation($deliveryNoteNumber: String!, $incomingGoodsPos: [IncomingGoodPosInput!]!) {
        setIncomingGoodsInformation(deliveryNoteNumber: $deliveryNoteNumber, incomingGoodsPos: $incomingGoodsPos)
    }
`;
